import { FunctionComponent, useMemo } from 'react';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';

const CONTENTS_PLACEHOLDER_ID = 'children';

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    generatedProperties?: { [key: string]: any };
    dynamicProperties?: Array<{ propertyName: string; propertyType: string; [key: string]: any }>;
}

const SchemaBuilder: FunctionComponent<commonTypes.WidgetInstanceProps> = (props) => {
    const appContext = commonHooks.useAppContext();
    const { inEditMode, Placeholder } = appContext;
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(
        props.widgetInstanceId
    );
    const { dynamicProperties = [], generatedProperties = {} } = widgetProperties || {};
    const { data, widgetInstanceId } = props;

    // Generate a set of valid property names from dynamicProperties
    const validPropertyNames = useMemo(() => {
        return new Set(dynamicProperties.map((property) => property.propertyName));
    }, [dynamicProperties]);

    // Filter out generated properties that do not exist in dynamicProperties
    const filteredGeneratedProperties = useMemo(() => {
        return Object.keys(generatedProperties).reduce(
            (acc, propertyName) => {
                if (validPropertyNames.has(propertyName)) {
                    acc[propertyName] = generatedProperties[propertyName];
                }
                return acc;
            },
            {} as { [key: string]: any }
        );
    }, [generatedProperties, validPropertyNames]);

    return (
        <>
            {inEditMode && <p>Schema Builder</p>}
            {widgetInstanceId && (
                <Placeholder
                    contentPlaceHolderId={CONTENTS_PLACEHOLDER_ID}
                    parentWidgetInstanceId={widgetInstanceId}
                    data={{ ...data, ...filteredGeneratedProperties }}
                />
            )}
        </>
    );
};

export default SchemaBuilder;
